import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { DeleteAccountPage } from "./pages/DeleteAccountPage";
import { SetupPasswordPage } from "./pages/SetupPasswordPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/delete-account" replace />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/setup-password" element={<SetupPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*" element={<Navigate to="/delete-account" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
